import React from "react";
import Icon from '@ant-design/icons';

const ZoomResetSvg = () => (
    <svg width='24' height='24' viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill='#000000'>
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M9.354 15.354L3.7 21H8v1H2v-6h1v4.285l5.646-5.639zM22 2h-6v1h4.3l-5.654 5.646.707.708L21 3.715V8h1zm-6 20h6v-6h-1v4.285l-5.646-5.639-.707.708L20.3 21H16zM8 2H2v6h1V3.715l5.646 5.639.707-.708L3.7 3H8z"></path><path fill="none" d="M0 0h24v24H0z"></path>
      </g>
    </svg>
);

const LensZoomResetSvg = () => (
<svg width="24px" height="24px" viewBox="0 0 32 32" id="i-zoom-reset" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="14" cy="14" r="12"></circle> <path d="M23 23 L30 30"></path> <path d="M9 12 L9 9 12 9 M16 9 L19 9 19 12 M9 16 L9 19 12 19 M19 16 L19 19 16 19"></path> </g></svg>
);


const ZoomReset = props => <Icon component={LensZoomResetSvg} {...props} />;


export default ZoomReset;